/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { lottieNameToFile } from "./lottie-animation.helper";
import type { AnimationNames } from "./lottie-animation.helper";

export async function importLottie(lottie: AnimationNames): Promise<any> {
	const lottieData = await import(`./animations/${lottieNameToFile(lottie)}.json`)
		.then((module) => module?.default)
		.catch((err) => {
			console.error("Error loading animation:", err);
		});
	return lottieData;
}
